import { ConfigProvider, Form, Input, message, Modal, Button } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import container from "@/lib/di/container";
import React from "react";
import { MODAL_THEME } from "@/core/themes/modal.theme";
import { usePermissionStore } from "@/core/stores/permission.store";
import { SaveButton } from "@/app/home/components/table/SaveButton";
import { DepartmentRepo } from "@/core/repos/tables/department.repo";
import { DepartmentModel } from "@/core/models/department.model";
import { SyncOutlined } from '@ant-design/icons';
import { useDrafts } from '@/core/stores/drafts.store';
import { ResetDraftButton } from '@/app/home/components/drafts/ResetDraftButton';

const departmentRepo = container.get(DepartmentRepo);

interface DetailModalProps {
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    data: DepartmentModel,
}

const INPUT_WIDTH = 450;

export const DetailModal: React.FC<DetailModalProps> = ({isModalOpen, setIsModalOpen, data}) => {
    const permissionStore = usePermissionStore();
    const [form] = Form.useForm<DepartmentModel>();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [messageApi, contextHolder] = message.useMessage();   
    // Draft logic for DepartmentModel
    const draft = useDrafts((state) => state.getDraft('DepartmentModel'));
    const _saveDraft = useDrafts((state) => state.saveDraft);
    const saveDraft = () => _saveDraft('DepartmentModel', form.getFieldsValue());
    const _clearDraft = useDrafts((state) => state.clearDraft);
    const clearDraft = () => {
        _clearDraft('DepartmentModel');
        form.setFieldsValue(data);
    };
    // Attach hooks to handle data changes
    const handleDataChange = async () => {
        form.setFieldsValue(data);
        if (data.id && data.id.length > 0) {
            setIsEdit(true);
        } else {
            if (draft) form.setFieldsValue(draft);
            setIsEdit(false);
        }
    }
    useEffect(() => {
        handleDataChange();
    }, [data])

    // Initialize select options data
    const init = async () => {}

    // componentDidMount equivalent, run exclusively on client-side
    useEffect(() => {init()}, []);


    const handleSave = async () => {
        try {
            setLoading(true);
            const formData = await form.validateFields();
            if (isEdit) {
                formData.id = data.id;
                const result = await departmentRepo.update({...data, ...formData});
                setIsModalOpen(false);
                if (result) {
                    messageApi.success({
                        content: "Đã cập nhật bản ghi"
                    })
                } else {
                    messageApi.error({
                        content: "Cập nhật bản ghi thất bại"
                    })
                }
            } else {
                const result = await departmentRepo.create({...data, ...formData});
                setIsModalOpen(false);
                clearDraft();
                if (result) {
                    messageApi.success({
                        content: "Thêm bản ghi mới thành công"
                    })
                } else {
                    messageApi.error({
                        content: "Thêm bản ghi mới thất bại"
                    })
                }
            }
        } catch (error) {
            console.log(error);
        }
        setLoading(false);
    };
    const handleCancel = () => {
      if (!isEdit) saveDraft();
      setIsModalOpen(false);
    };

    return (
        <ConfigProvider theme={MODAL_THEME}>
            {contextHolder}
            <Modal open={isModalOpen} onCancel={handleCancel} width={510} centered
            styles={{
                mask: {
                    backdropFilter: 'blur(2px)',
                    backgroundColor: 'var(--primary-mask)'
                }
            }}
            footer={[
                <div key={1} className="w-full flex flex-row justify-end px-1.5">
                    <SaveButton isEdit={isEdit} loading={loading} onClick={handleSave}/>
                </div>,
            ]}>
                <div className="flex flex-row w-full items-center justify-start select-none">
                    <p className="ml-2 text-2xl font-bold text-primary">CHI TIẾT PHÒNG BAN</p>
                    {!isEdit && <ResetDraftButton onClick={clearDraft} />}
                </div>
                <div className="flex flex-row justify-center mt-6">
                    <Form<DepartmentModel>
                        name="basic"
                        className="flex flex-col items-end"
                        form={form}
                        layout="vertical"
                        disabled={isEdit&&!permissionStore.page.edit}
                    >
                        <div className="grid grid-cols-1 gap-x-4 items-end">
                            <Form.Item<DepartmentModel>
                                label="Mã phòng ban"
                                name="code"
                                rules={[{ required: true, message: 'Trường này là bắt buộc!' }, {max: 4, message: 'Mã phòng ban không được vượt quá 4 ký tự'}]}
                            >
                                <Input placeholder="Nhập Mã phòng ban" style={{width: INPUT_WIDTH}} disabled={isEdit}></Input>
                            </Form.Item>

                            <Form.Item<DepartmentModel>
                                label="Tên phòng ban"
                                name="name"
                                rules={[{ required: true, message: 'Trường này là bắt buộc!' }]}
                            >
                                <Input placeholder="Nhập Tên phòng ban" style={{width: INPUT_WIDTH}}></Input>
                            </Form.Item>

                            <Form.Item<DepartmentModel>
                                label="Mô tả"
                                name="information"
                            >
                                 <Input.TextArea placeholder="Nhập mô tả" style={{width: INPUT_WIDTH, height: 202, resize: "none"}}></Input.TextArea>
                            </Form.Item>

                        </div>
                    </Form>
                </div>
                <div className="mb-5 mx-2 border-t border-dashed border-gray-300"></div>
            </Modal>
        </ConfigProvider>
    )
}